import { RootState } from 'duck/store'
import { connect } from 'react-redux'

import { updateSearch } from '../../duck/actions'
import { getSearchParams } from '../../duck/selectors'

import OrganizationTextFilter, { OrganizationTextFilterProps } from './OrganizationTextFilter.presentational'

const mapStateToProps = (state: RootState): StateProps => {
  const { search } = getSearchParams(state)
  const searchField = state.router.location.query.search
  return {
    search,
    searchField,
  }
}

type StateProps = Omit<OrganizationTextFilterProps, 'onChangeSearch'>

const mapDispatchToProps = {
  onChangeSearch: updateSearch,
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationTextFilter)
